import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {FormField} from "@angular/forms/signals";
import {DateFormatPipe} from '../pipes/date-format.pipe';
import {DateParsePipe} from '../pipes/date-parse.pipe';
import {TimeParsePipe} from '../pipes/time-parse.pipe';
import {DayOfWeekParsePipe} from '../pipes/day-of-week-parse.pipe';
import {ListFilterPipe} from '../pipes/list-filter.pipe';
import {ListSortPipe} from '../pipes/list-sort.pipe';
import {EnumParsePipe} from '../pipes/enum-parse.pipe';
import {EnumArrayParsePipe} from '../pipes/enum-array-parse.pipe';
import {OptTaskFilterPipe} from '../pipes/opt-task-filter.pipe';
import {RemoveWhiteSpacePipe} from '../pipes/remove-white-space.pipe';
import {BaseChartDirective} from 'ng2-charts';
import {TimeSlotDirective} from '../directives/time-slot.directive';
import {HorizontalTimeSlotDirective} from '../directives/horizontal-time-slot.directive';
import {NgbdSortableHeaderDirective} from '../directives/sortable.directive';
import {GoogleSigninButtonDirective} from '../directives/google-signin-button.directive';
import {HeaderComponent} from './components/header/header.component';
import {StoreSearchComponent} from './components/store-search/store-search.component';
import {ModalComponent} from './components/modal/modal.component';
import {InputDateComponent} from './components/input-date/input-date.component';
import {CheckboxGroupComponent} from './components/checkbox-group/checkbox-group.component';
import {RuleCheckerComponent} from './components/rule-checker/rule-checker.component';
import {SortableTableComponent} from "./components/sortable-table/sortable-table.component";
import {StoreNavigationComponent} from "./components/store-navigation/store-navigation.component";

export const SHARED_IMPORTS = [
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  NgbModule,
  AutocompleteLibModule,
  FormField,

  // Pipes
  DateFormatPipe,
  DateParsePipe,
  TimeParsePipe,
  DayOfWeekParsePipe,
  ListFilterPipe,
  ListSortPipe,
  EnumParsePipe,
  EnumArrayParsePipe,
  OptTaskFilterPipe,
  RemoveWhiteSpacePipe,

  // Directives
  TimeSlotDirective,
  HorizontalTimeSlotDirective,
  NgbdSortableHeaderDirective,
  GoogleSigninButtonDirective,
  BaseChartDirective,

  // Shared Components
  HeaderComponent,
  StoreSearchComponent,
  ModalComponent,
  InputDateComponent,
  CheckboxGroupComponent,
  SortableTableComponent,
  StoreNavigationComponent,
  RuleCheckerComponent
];